<template>
	<b-container>
		<b-card no-body header="THEMES" class="text-center font-weight-bold h-100 mt-2">
			<b-row cols="12" class="pt-2">
				<b-col xl="3">
					<b-form-select v-model="selectedTheme" :options="listThemes"
								   value-field="Name"
								   text-field="Label"
								   size="sm"
								   plain
								   class="align-middle align-items-center" />
				</b-col>
			</b-row>
		</b-card>
	</b-container>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

    @Component({
        components: {

        }
    })
	export default class PersonalizationAdmin extends Vue {

		private bodyElement: HTMLElement = document.body;
		private htmlElement: HTMLElement = document.documentElement;

		private currentTheme = localStorage.getItem('theme');
		private selectedTheme: string = "";

		private listThemes: { Name: string, Label: string }[] = [
			{ Name: "default", Label: "Par défaut" },
			{ Name: "red", Label: "Vermillon" },
			{ Name: "emerald", Label: "Emeraude" },
			{ Name: "mandarine", Label: "Mandarine" },
			{ Name: "bleuet", Label: "Bleuet" },
			{ Name: "amethyste", Label: "Amethyste" },
			{ Name: "acier", Label: "Acier" },
		];

		async mounted() {
			if (this.currentTheme) {
				localStorage.setItem("theme", this.currentTheme);
				this.htmlElement.setAttribute('theme', this.currentTheme)
				this.selectedTheme = this.currentTheme;
			}
			else {
				localStorage.setItem("theme", 'default');
				this.htmlElement.setAttribute('theme', 'default');
				this.selectedTheme = 'default';
			}
		}

		@Watch('selectedTheme' , { immediate: true })
		private switchColorTheme() {
			if (this.selectedTheme) {
				localStorage.setItem("theme", this.selectedTheme);
				this.htmlElement.setAttribute('theme', this.selectedTheme);
			}
			else {
				localStorage.setItem("theme", 'default');
				this.htmlElement.setAttribute('theme', 'default');
			}
		}
    }
</script>

<style scoped>
</style>